import {
  Box,
  IconButton,
  styled,
  useTheme
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CompanyLogo from '../../../icons/nete2.png';
import NotiStackProvider from '../../../components/NotiStackProvider';
import Notification from './Notification';
import ProfileMenu from './ProfileMenu';
import ProjectLogo from '../../../icons/siriuslogoWhite.svg';
import PubSub from 'pubsub-js';
import Question from './Question';
import SideBarManagementMenu from '../Sidebar/SidebarMenu/SideBarManagementMenu';
import { pageNotiState } from '../../../slices/pageNotificationSlice';
import { routeList } from '../../../router/routerLink';
import { useSelector } from "react-redux";

/// release-ship branch
// import DSAIDIcon from '../../../icons/DSAID_logo.png';
// import GovTechIcon from '../../../icons/govtech-white.png';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};      
        margin-left:${theme.sidebar.width};  
        background: ${theme.header.background}; 
        justify-content: space-between; 
        border-bottom: 1px solid #343B5E; 
`
);


function Header() {
  const { notification } = useSelector(pageNotiState);
  const location = useLocation();
  const theme = useTheme();
  const [showManage, setShowManage] = useState(false)
  const [openDrawer, setOpenDrawer] = useState(true);
  useEffect(() => {
    setShowManage(false)
    {
      routeList.forEach(r => {
        const match = matchPath({
          path: r,
          end: true
        }, location.pathname)
        if (match) {
          setShowManage(true)
        }
      })
    }
    if (location.pathname != '/liveview') {
      setOpenDrawer(true);
    }
  }, [location.pathname])
  // open drawer in the header with pubsub pattern
  useEffect(() => {
    const openDrawerSubscriber = function (topic) {
      if (topic == 'OPEN_DRAWER_TOPIC') {
        setOpenDrawer(true);
      }
    };
    PubSub.subscribe('OPEN_DRAWER_TOPIC', openDrawerSubscriber);
    return () => {
      PubSub.unsubscribe(openDrawerSubscriber)
    }
  }, [])

  // close drawer in the header with pubsub pattern
  useEffect(() => {
    const closeDrawerSubscriber = function (topic) {
      if (topic == 'CLOSE_DRAWER_TOPIC') {
        setOpenDrawer(false);
      }
    };
    PubSub.subscribe('CLOSE_DRAWER_TOPIC', closeDrawerSubscriber);
    return () => {
      PubSub.unsubscribe(closeDrawerSubscriber)
    }
  }, [])
  return (
    <>
      <HeaderWrapper
        display="flex"
        alignItems="center"
      >
        <Box
          sx={{
            display: 'flex', 
            marginLeft: openDrawer && location.pathname == '/liveview' ? (theme.drawer.width + 25) + 'px' : '25px'
          }}
        >

          {/*
          //for release-ship branch
       <Box sx={{marginTop: '5px'}}>
        <img src={DSAIDIcon} alt = "DSAID" width="60px" ></img> 
      </Box>
      <Box sx={{marginLeft: "8px", marginTop: '2px'}}>
        <img src={GovTechIcon} alt = "GovTech" width="120px" ></img>
      </Box> 
     */}

          {/* for release branch */}
          <Box sx={{ marginTop: '5px' }}>
            <img src={CompanyLogo} alt="nete2" height="40px" />
          </Box>
          <Box sx={{ marginTop: '5px', marginLeft: "8px" }}>
            <img src={ProjectLogo} alt="GovTech" width="120px" />
          </Box>

        </Box>
        <Box>
          {showManage &&
            <SideBarManagementMenu />
          }
        </Box>
        <IconButton
          onClick={() => {
            PubSub.publish('OPEN_DRAWER_TOPIC');
          }}
          style={{
            visibility: location.pathname == '/liveview' ? 'visible' : 'hidden',
            marginLeft: '-17px',
            position: 'absolute'
          }}>
          <ChevronRightIcon />
        </IconButton>
        <Box
          sx={{ direction:'row',justifyContent:'center',display:'flex' }}>
          <Box sx={{ flexGrow: 1 }} >
            <NotiStackProvider pageNotification={notification} />
          </Box>
          <Question />
          <Notification />
          <ProfileMenu />
        </Box>
      </HeaderWrapper>
    </>
  );
}

export default Header;
